import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useValidateUserTokenLazyQuery } from '../types/graphql'

export const useValidateUserToken = (): void => {
  const history = useHistory()
  const { pathname } = useLocation()

  const [validateUserTokenLazyQuery] = useValidateUserTokenLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data.ValidateUserToken === true) return
    },
    onError: () => {
      history.push({ pathname: '/login', state: { redirect: true, redirectFrom: pathname } })
    },
  })

  useEffect(() => {
    validateUserTokenLazyQuery()
  }, [validateUserTokenLazyQuery])
}
